import styled from "styled-components";

export const IdentityCellWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
`;

export const IdentityCellImageSlot = styled.div<{ $size: "sm" | "md" }>`
  flex-shrink: 0;
  width: ${({ $size }) => ($size === "sm" ? "2.5rem" : "3rem")};
  height: ${({ $size }) => ($size === "sm" ? "2.5rem" : "3rem")};
`;

export const IdentityCellCopy = styled.div`
  min-width: 0;
`;

export const IdentityCellTitle = styled.p`
  color: var(--brand-ink);
  font-weight: 500;
  line-height: 1.35;
`;

export const IdentityCellSubtitle = styled.p`
  color: var(--brand-muted);
  font-size: 0.75rem;
  line-height: 1.4;
  margin-top: 0.15rem;
`;
